import React from 'react';
import TranslatedCopy from '../../intl/translated-copy';

const FormInputHelpMessage = (props) => {
  const {
    copyID,
    name,
  } = props;

  return (
    <div
      className='FormInput-help'
      role='tooltip' >
      <TranslatedCopy
        copyID={ copyID }
        id={ `${name}-help-text` } />
    </div>
  );
};

export default FormInputHelpMessage;
